import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <Timeline
                metricType="primary"
                chartSize="lg"
                data={this.state.data}
                error={this.state.error}
                keys={keys(this.state.isDark, t)}
                parent_id={this.props.parent_id}
                content_id={this.props.content_id}
                forceRun={this.forceRun}
                hasRightAxis
                rightAxisLabel={t('global.ctr_per')}
                hasLeftSecondAxis
                leftAxisLabel={t('global.impressions')}
                leftSecondAxisLabel={t('global.clicks')}
                hasSecondRightAxis
            />
        );
    }
}

export default withTranslation()(Summary);
